import { defineMessages } from 'react-intl';

export const ScopeName = 'Pages.ViewRedemption';

const Scope = defineMessages({
  title: {
    id: `${ScopeName}.title`,
    defaultMessage: 'Página de Visualização de Solicitação',
  },
  msgErrorModule: {
    id: `${ScopeName}.msgErrorModule`,
    defaultMessage: 'Não foi possível carregar o módulo federado',
  },
});

export default Scope;
